// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const HELP_FORM_ACK_EMAIL = "D\u011bkujeme za zpr\u00e1vu. Sleduj sv\u016fj email.";
export const HELP_FORM_ACK_INTERNAL_MAIL = "D\u011bkujeme za zpr\u00e1vu. Sleduj svou intern\u00ed po\u0161tu.";
